import React, { useEffect,useState} from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { Grid } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    height: 140,
    width: 100,
  },
  control: {
    padding: theme.spacing(2),
  },
}));

export default function FormularioSeguimiento(props) {
  const {
    register,
    errors,
    defaultItem,
    ctl,
    watch,
    setValue,
    id,
    getValues,
    state
  } = props;
  const classes = useStyles();
  const [data, setData] = useState([]);
  const handleChange = (event, value) => {
    if (value.length > 0) {
      setValue("responsables", value);
    } else setValue("responsables", null);
  };
  const isEdicion = defaultItem.titulo ? true : false;
  const requerido = { required: { value: true, message: 'Campo requerido' } };

  useEffect(() => {
    let fil1 = ctl.personas.map((m)=> m.idpersona);
    let fil2 = ctl.integrantes.filter((m)=> !fil1.includes(m.idpersona)).map((m)=>{
      return {
       idsolicitud: state.id,
       idmalcance: null,
       idpersona: m.idpersona,
       nombre: m.npersona,
       idpropuesta: state.idpropuesta
      }
    });
    setData(fil2);
  }, []);
  return (
    <Grid container className={classes.root} spacing={2}>

      <Grid item md={12} xs={12}>
        <Autocomplete
          multiple
          options={data}
          getOptionLabel={(option) => option.nombre}
          getOptionSelected={(option, value) =>
            option.idpersona == value.idpersona
          }
          onChange={handleChange}
          size="small"
          fullWidth
          inputRef={register("responsables", {
            required: { value: true, message: "CAMPO REQUERIDO" },
          })}
          renderInput={(params) => (
            <TextField
              label="MIEMBROS DEL EQUIPO"
              variant="outlined"
              {...params}
              rules={requerido}
              error={errors.responsables != undefined}
              helperText={errors.responsables}
              required={getValues("responsables")?.length === 0}

            />
          )}
        />
      </Grid>



    </Grid>
  );
}
